<h1>{{section.title}}</h1>

<form #sectionForm="ngForm" class="elements-container" novalidate>
  <fieldset [disabled]="(isSubmitting$ | async)" [class.disabled]="(isSubmitting$ | async)">
    <ng-container *ngFor="let element of orderedElements">
      <ng-container [ngSwitch]="element.element_object_type">
        <!-- Nested Groups of elements -->
        <ng-container *ngSwitchCase="'group'">
          <div class="flex-container">
            <ng-container *ngFor="let group_element of element.elements">
              <div
                *ngIf="renderedFormService.objectIsVisible(group_element)"
                class="{{groupClass(group_element)}}"
              >
                <div class="elements-container--element {{group_element.configuration['elementClass']}}">
                  <ng-container
                    *ngTemplateOutlet="whichTemplate(group_element); context: { element: group_element };"
                  ></ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- Otherwise, just display single element -->
        <ng-container *ngSwitchDefault>
          <div
            *ngIf="renderedFormService.objectIsVisible(element)"
            class="elements-container--element {{element.configuration['elementClass']}} {{elementObjectTypeClass(element)}}"
          >
            <ng-container
              *ngTemplateOutlet="whichTemplate(element); context: { element: element };"
            ></ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </fieldset>

  <!-- ******************************************************** -->
  <!-- FIELD TEMPLATE -->
  <!-- These templates MUST live inside form element in order to be registered with ngTemplateOutlet above -->
  <ng-template #defaultTemplate>
    Element Not found
  </ng-template>

  <!-- Hidden Text -->
  <ng-template #hiddenTemplate let-element="element">
    <input type="hidden"
      [name]="element.element_object.custom_variable_key || element.element_object.id"
      [(ngModel)]="element.element_object.default_value"
    />
  </ng-template>

  <!-- Fixed Text -->
  <ng-template #fixedTextTemplate let-element="element">
    <input type="hidden"
      [name]="element.element_object.custom_variable_key || element.element_object.id"
      [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
    />
  </ng-template>

  <!-- Text Input -->
  <ng-template #textInputTemplate let-element="element">
    <p
      class="question" [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
    ></p>

    <label>
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" floatLabel="always">
        <input matInput
          (blur)="updateFormValues()"
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [autocomplete]="element.configuration.autocomplete || 'off'"
          [disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
            || forceReadonly
          "
          [maskito]="MASKS[element.configuration.maskFunction]"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [pattern]="PATTERNS[element.configuration.pattern]"
          [placeholder]="element.configuration.placeholder"
          [readonly]="element.element_object.read_only || forceReadonly"
          [required]="element.element_object.required"
          spellcheck="false"
        />
        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Password -->
  <ng-template #passwordTemplate let-element="element" let-showpassword="showPassword">
    <p
      class="question"
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
    ></p>

    <label>
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" floatLabel="always">
        <ng-container *ngIf="element.configuration.maskFunction">
          <input matInput
            (blur)="updateFormValues()"
            [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
            [autocomplete]="element.configuration.autocomplete || 'off'"
            [disabled]="
              element.element_object.read_only
              || (isSubmitting$ | async)
              || (taskLoading$ | async)
              || forceReadonly
            "
            [name]="element.element_object.custom_variable_key || element.element_object.id"
            [placeholder]="element.configuration.placeholder"
            [readonly]="element.element_object.read_only || forceReadonly"
            [required]="element.element_object.required"
            [type]="showPassword ? 'text' : 'password'"
            spellcheck="false"
          />
        </ng-container>
        <ng-container *ngIf="!element.configuration.maskFunction">
          <input matInput
            (blur)="updateFormValues()"
            [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
            [autocomplete]="element.configuration.autocomplete || 'off'"
            [disabled]="
              element.element_object.read_only
              || (isSubmitting$ | async)
              || (taskLoading$ | async)
              || forceReadonly
            "
            [name]="element.element_object.custom_variable_key || element.element_object.id"
            [placeholder]="element.configuration.placeholder"
            [readonly]="element.element_object.read_only || forceReadonly"
            [required]="element.element_object.required"
            [type]="showPassword ? 'text' : 'password'"
            spellcheck="false"
          />
        </ng-container>
        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>

        <button *ngIf="!showPassword" matSuffix mat-icon-button (click)="showPassword = true">
          <span class="icon-visible" inlineSVG="/assets/icons/eye.svg"></span>
        </button>
        <button *ngIf="showPassword" matSuffix mat-icon-button (click)="showPassword = false">
          <span class="icon-visible" inlineSVG="/assets/icons/eye-off.svg"></span>
        </button>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Multiline -->
  <ng-template #textAreaTemplate let-element="element">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>
    <label *ngIf="!element.configuration.richEditor">
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" floatLabel="always">
        <textarea matInput
          (blur)="updateFormValues()"
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
            || forceReadonly
          "
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [readonly]="element.element_object.read_only || forceReadonly"
          [required]="element.element_object.required"
          spellcheck="false"
          style="min-height: 80px;"
        ></textarea>
        <mat-hint [innerHtml]="element.element_object.tooltip | safeHtml" *ngIf="element.configuration.questionLocation !== 'above'"></mat-hint>
      </mat-form-field>
    </label>

    <label *ngIf="element.configuration.richEditor ==='true'">
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" class="rich-editor" floatLabel="always">
        <input matInput
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
            || forceReadonly
          "
          [hidden]="true"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [readonly]="element.element_object.read_only || forceReadonly"
          [required]="element.element_object.required"
        />

        <fl-froala-editor
          [froalaEditor]="froalaHelper.formElement"
          [(froalaModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
        ></fl-froala-editor>

        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Slide Toggle -->
  <ng-template #slideToggleTemplate let-element="element">
    <p
      class="question"
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
    ></p>
    <mat-slide-toggle
      (change)="updateFormValues()"
      [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
      [disabled]="
        element.element_object.read_only
        || (isSubmitting$ | async)
        || (taskLoading$ | async)
        || forceReadonly
      "
      [name]="element.element_object.custom_variable_key || element.element_object.id"
    >{{element.element_object.label}}</mat-slide-toggle>
    <mat-hint
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation !== 'above'"
    ></mat-hint>
  </ng-template>

  <!-- Checkbox -->
  <ng-template #checkboxTemplate let-element="element">
    <p
      class="question"
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
    ></p>

    <mat-checkbox
      (change)="onCheckboxChange($event, element.element_object.custom_variable_key)"
      [checked]="booleanCastedValue(renderedFormService.dynamicModels[element.element_object.custom_variable_key])"
      [disabled]="
        element.element_object.read_only
        || (isSubmitting$ | async)
        || (taskLoading$ | async)
        || forceReadonly
      "
      [name]="element.element_object.custom_variable_key || element.element_object.id"
    >
      {{element.element_object.label}}
    </mat-checkbox>
    <mat-hint
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation !== 'above'"
    ></mat-hint>
  </ng-template>

  <!-- Multi Option Dropdown -->
  <ng-template #multiSelectTemplate let-element="element">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>

    <label>
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        [attr.data-testid]="
          'multi-select-'
          + element.element_object.custom_variable_key || element.element_object.id
        "
      >
        <mat-select
          (selectionChange)="updateFormValues()"
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
            || forceReadonly
          "
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [placeholder]="element.configuration.placeholder"
          [required]="element.element_object.required"
        >
          <mat-option *ngFor="let option of element.element_object.field_options"
                      [value]="option.value">
            <span [innerHtml]="option.raw_html | safeHtml"></span>
          </mat-option>
        </mat-select>

        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Radio Group -->
  <ng-template #radioTemplate let-element="element">
    <p
      class="question"
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
    ></p>

    <div
      class="direction-{{element.configuration.direction}}"
      [class.invalid]="
        element.element_object.required
        && (showWarningOnUpdate$ | async)
        && renderedFormService.dynamicModels[element.element_object.custom_variable_key] === null
      "
    >
      <input
        [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
        [name]="element.element_object.custom_variable_key || element.element_object.id"
        [required]="element.element_object.required"
        type="hidden"
      />

      <mat-radio-group
        (change)="updateFormValues()"
        [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
        [disabled]="
          element.element_object.read_only
          || (isSubmitting$ | async)
          || (taskLoading$ | async)
          || forceReadonly
        "
        [ngModelOptions]="{standalone: true}"
        [required]="element.element_object.required"
      >
        <p
          [class.disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
          "
          class="radio-group-label"
        >
          {{element.element_object.label}}
          <ng-container *ngIf="element.element_object.required">*</ng-container>
        </p>
        <mat-radio-button
          *ngFor="let option of element.element_object.field_options"
          [value]="option.value"
        >
          <span [innerHtml]="option.raw_html | safeHtml"></span>
        </mat-radio-button>
        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-radio-group>
    </div>
  </ng-template>

  <!-- Date Picker -->
  <ng-template #datePickerTemplate let-element="element">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>
    <label>
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" floatLabel="always">
        <input matInput
          (change)="updateFormValues()"
          (click)="onDatePickerClick(picker, element)"
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [disabled]="
            element.element_object.read_only
            || (isSubmitting$ | async)
            || (taskLoading$ | async)
            || forceReadonly
          "
          [matDatepicker]="picker"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [placeholder]="element.configuration.placeholder"
          [required]="element.element_object.required"
          readonly
        />
        <mat-datepicker-toggle matSuffix [for]="picker">
          <span matDatepickerToggleIcon class="icon-calendar" inlineSVG="/assets/icons/calendar.svg"></span>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Custom Options -->
  <ng-template #customTemplate let-element="element" let-touched="false">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>

    <input
      [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
      [name]="element.element_object.custom_variable_key || element.element_object.id"
      [required]="element.element_object.required"
      type="hidden"
    />

    <mat-form-field class="custom-options">
      <div class="custom-options-container">
        <input matInput
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [disabled]="(isSubmitting$ | async) || (taskLoading$ | async) || forceReadonly"
          [hidden]="true"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [required]="element.element_object.required"
        />

        <div class="flex-container">
          <div
            (click)="setCustomValue(element.element_object.custom_variable_key, option.value)"
            [class.readonly]="(isSubmitting$ | async) || (taskLoading$ | async) || forceReadonly"
            [class.selected]="customOptionSelected(renderedFormService.dynamicModels[element.element_object.custom_variable_key], option.value)"
            [innerHtml]="option.raw_html | safeHtml"
            *ngFor="let option of element.element_object.field_options"
            class="flex-cell-1 flex-container-vertical"
          ></div>
        </div>
      </div>
    </mat-form-field>
  </ng-template>

  <!-- Document Upload -->
  <ng-template #documentTemplate let-element="element">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>
    <label>
      <span class="label-text">{{element.element_object.label}}{{ element.element_object.required ? ' *' : '' }}</span>
      <mat-form-field appearance="outline" floatLabel="always">
        <input matInput
          (click)="onUploadWidgetClick(element.element_object.custom_variable_key, element.configuration.accept)"
          [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [placeholder]="element.configuration.placeholder || 'Click to upload a document'"
          [required]="element.element_object.required"
          *ngIf="!renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          readonly="readonly"
        />
        <input matInput
          (click)="onUploadWidgetClick(element.element_object.custom_variable_key, element.configuration.accept)"
          [name]="element.element_object.custom_variable_key || element.element_object.id"
          [required]="element.element_object.required"
          *ngIf="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
          placeholder="Click to replace {{renderedFormService.dynamicModels[element.element_object.custom_variable_key]['title']}}"
          readonly="readonly"
        />

        <button matSuffix mat-icon-button
          *ngIf="renderedFormService.dynamicDocumentTitles[element.element_object.custom_variable_key]"
          (click)="
            renderedFormService.dynamicModels[element.element_object.custom_variable_key] =
            renderedFormService.dynamicDocumentTitles[element.element_object.custom_variable_key] = null
          "
        >
          <mat-icon>cancel</mat-icon>
        </button>
        <button matSuffix mat-icon-button
          (click)="onUploadWidgetClick(element.element_object.custom_variable_key, element.configuration.accept)"
        >
          <span class="icon-upload" inlineSVG="/assets/icons/upload.svg"></span>
        </button>

        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>

    <div
      *ngIf="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
      class="file-upload-preview-container"
    >
      <span class="sub-label">Currently Uploaded</span>

      <!-- Making this a list to support multiple file uploads in the future -->
      <ul class="uploaded-files">
        <li>
          <a
            href="{{renderedFormService.dynamicModels[element.element_object.custom_variable_key]['signed_url']}}"
            target="_blank"
          >
            {{renderedFormService.dynamicModels[element.element_object.custom_variable_key]['title']}}
          </a>
          <button mat-icon-button (click)="onRemoveDocumentUpload(element.element_object.custom_variable_key)">
            <span class="icon-visible" inlineSVG="/assets/icons/close-2.svg"></span>
          </button>
        </li>
      </ul>
    </div>

    <input
      (change)="updateFormValues()"
      [(ngModel)]="renderedFormService.dynamicModels[element.element_object.custom_variable_key]"
      [disabled]="(isSubmitting$ | async) || (taskLoading$ | async) || forceReadonly"
      [ngModelOptions]="{standalone: true}"
      [required]="element.element_object.required"
      type="hidden"
    />
  </ng-template>

  <!-- Signature -->
  <ng-template #signatureTemplate let-element="element">
    <p
      [innerHtml]="element.element_object.tooltip | safeHtml"
      *ngIf="element.configuration.questionLocation === 'above'"
      class="question"
    ></p>

    <label>
      <span class="label-text">Signature *</span>
      <mat-form-field appearance="outline" floatLabel="always" class="signature-form-field">
        <button
          mat-button
          (click)="openSignatureDialog('SIGNATURE')"
          *ngIf="!renderedFormService.dynamicModels['SIGNATURE'] || !appliedSignature"
          class="iconic signature-button"
          color="primary-light"
        >
          <span class="icon-signature" inlineSVG="/assets/icons/pen.svg"></span>
          Click here to Sign
        </button>

        <div *ngIf="appliedSignature" class="signature-font" (click)="openSignatureDialog('SIGNATURE')">
          {{renderedFormService.dynamicModels['SIGNATURE']}}
        </div>

        <input matInput
          [required]="true"
          [hidden]="true"
          name="signature"
          [(ngModel)]="renderedFormService.dynamicModels['DOES_NOT_EXIST']"
          *ngIf="!appliedSignature"
          [disabled]="(isSubmitting$ | async) || (taskLoading$ | async) || forceReadonly"
        />
        <input matInput
          [required]="true"
          [hidden]="true"
          name="signature"
          [(ngModel)]="renderedFormService.dynamicModels['SIGNATURE']"
          *ngIf="appliedSignature"
          [disabled]="(isSubmitting$ | async) || (taskLoading$ | async) || forceReadonly"
          (change)="updateFormValues()"
        />
        <mat-hint
          [innerHtml]="element.element_object.tooltip | safeHtml"
          *ngIf="element.configuration.questionLocation !== 'above'"
        ></mat-hint>
      </mat-form-field>
    </label>
  </ng-template>

  <!-- Content -->
  <ng-template #contentTemplate let-element="element">
    @if (!!element.configuration.expandableContent) {
      <mat-expansion-panel *ngIf="visibleContent(form, element)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ element.element_object.title }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          [innerHTML]="element.element_object.parsed_raw_html | safeHtml"
        ></div>
      </mat-expansion-panel>
    } @else {
      <div
        [innerHTML]="element.element_object.parsed_raw_html | safeHtml"
        *ngIf="visibleContent(form, element)"
      ></div>
    }
  </ng-template>
</form>
